import { Injectable, signal } from '@angular/core'
import { AlbertModalConfig, AlbertModalSlot } from '../components/albert-modal/albert-modal.types'

@Injectable({
  providedIn: 'root'
})
export class AlbertModalService {
  private readonly _config = signal<AlbertModalConfig | null>(null)
  public readonly config = this._config.asReadonly()
  // Modals with content get their own slot, so errors and prompts open above them instead of replacing them.
  private readonly _contentConfig = signal<AlbertModalConfig | null>(null)
  public readonly contentConfig = this._contentConfig.asReadonly()
  // The leave-page prompt sits between the two: above content modals, below the errors of its own save.
  private readonly _promptConfig = signal<AlbertModalConfig | null>(null)
  public readonly promptConfig = this._promptConfig.asReadonly()

  public show(config: AlbertModalConfig): void {
    this._config.set(config)
  }

  public hide(): void {
    this._config.set(null)
    this.releaseScroll()
  }

  public showContent(config: AlbertModalConfig): void {
    this._contentConfig.set(config)
  }

  public hideContent(): void {
    this._contentConfig.set(null)
    this.releaseScroll()
  }

  public showPrompt(config: AlbertModalConfig): void {
    this._promptConfig.set(config)
  }

  public hidePrompt(): void {
    this._promptConfig.set(null)
    this.releaseScroll()
  }

  public hideSlot(slot: AlbertModalSlot): void {
    switch (slot) {
      case 'content':
        this.hideContent()
        break
      case 'prompt':
        this.hidePrompt()
        break
      case 'default':
        this.hide()
    }
  }

  // Prevent the disability to scroll after modal close, unless another modal is still open.
  private releaseScroll(): void {
    if (this._config() === null && this._promptConfig() === null && this._contentConfig() === null) {
      document.body.classList.remove('p-overflow-hidden')
    }
  }
}
